import React from "react";

const defaultTimeHorizonABCTableData = [
  {
    sno: 1,
    riskOrOpportunityABC: "",
    shortA: "",
    shortB: "",
    shortC: "",
    mediumA: "",
    mediumB: "",
    mediumC: "",
    longA: "",
    longB: "",
    longC: "",
  },
];

const TimeHorizonABCTable = ({
  timeHorizonABCTableData,
  setTimeHorizonABCTableData,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...timeHorizonABCTableData];
    updated[index][field] = value;
    setTimeHorizonABCTableData(updated);
  };
  const renumberRows = (arr) => arr.map((r, i) => ({ ...r, sno: i + 1 }));

  const addRow = () =>
    setTimeHorizonABCTableData([
      ...timeHorizonABCTableData,
      {
        sno: (timeHorizonABCTableData?.length || 0) + 1,
        riskOrOpportunityABC: "",
        shortA: "",
        shortB: "",
        shortC: "",
        mediumA: "",
        mediumB: "",
        mediumC: "",
        longA: "",
        longB: "",
        longC: "",
      },
    ]);

  const removeRow = () => {
    if (timeHorizonABCTableData.length > 1) {
      setTimeHorizonABCTableData(
        renumberRows(timeHorizonABCTableData.slice(0, -1))
      );
    }
  };

  // remove per-cell borders; outer frame + inner grid will handle perfect corners
  const cell = {
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };
  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };
  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };
  const buttonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  return (
    <div style={{ overflowX: "auto", marginTop: 20 }}>
      {/* table frame + perfect corners */}
      <style>{`
        .abcTableFrame{
          border: 1px solid #000;
          border-radius: 8px;
          overflow: hidden;
        }
        .abcTable{
          width: 100%;
          border-collapse: collapse;
        }
        .abcTable th,
        .abcTable td{
          border: 1px solid #000; /* inner grid lines */
          padding: 15px;
          vertical-align: top;
          text-align: left;
        }
        .abcTable thead th{
          background: #d3c9ce;
          font-weight: 700;
          text-align: center;
        }
        /* hide only the outer edges; the frame draws the outside border */
        .abcTable thead tr:first-child th{ border-top: 0; }
        .abcTable tr th:first-child,
        .abcTable tr td:first-child{ border-left: 0; }
        .abcTable tr th:last-child,
        .abcTable tr td:last-child{ border-right: 0; }
        .abcTable tbody tr:last-child td{ border-bottom: 0; }
      `}</style>

      <div className="abcTableFrame">
        <table className="abcTable">
          <thead>
            <tr>
              <th style={{ ...header }} rowSpan={2}>
                S.
                <br />
                NO.
              </th>
              <th style={header} rowSpan={2}>
                Risk/Opportunity
              </th>
              <th style={header} colSpan={3}>
                Short Term
              </th>
              <th style={header} colSpan={3}>
                Medium Term
              </th>
              <th style={header} colSpan={3}>
                Long Term
              </th>
            </tr>
            <tr>
              <th style={header}>A</th>
              <th style={header}>B</th>
              <th style={header}>C</th>
              <th style={header}>A</th>
              <th style={header}>B</th>
              <th style={header}>C</th>
              <th style={header}>A</th>
              <th style={header}>B</th>
              <th style={header}>C</th>
            </tr>
          </thead>

          <tbody>
            {timeHorizonABCTableData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>{row.sno || index + 1}.</td>

                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.riskOrOpportunityABC}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "riskOrOpportunityABC",
                        e.target.value
                      )
                    }
                    style={inputStyle}
                  />
                </td>

                {/* Short Term A/B/C */}
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.shortA}
                    onChange={(e) =>
                      handleChange(index, "shortA", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.shortB}
                    onChange={(e) =>
                      handleChange(index, "shortB", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.shortC}
                    onChange={(e) =>
                      handleChange(index, "shortC", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>

                {/* Medium Term A/B/C */}
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.mediumA}
                    onChange={(e) =>
                      handleChange(index, "mediumA", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.mediumB}
                    onChange={(e) =>
                      handleChange(index, "mediumB", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.mediumC}
                    onChange={(e) =>
                      handleChange(index, "mediumC", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>

                {/* Long Term A/B/C */}
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.longA}
                    onChange={(e) =>
                      handleChange(index, "longA", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.longB}
                    onChange={(e) =>
                      handleChange(index, "longB", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.longC}
                    onChange={(e) =>
                      handleChange(index, "longC", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 10,
          gap: 10,
        }}
      >
        <button onClick={removeRow} style={buttonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={buttonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

export default TimeHorizonABCTable;
